import React from 'react';

const h = React.createElement;

/**
 * @param {object} p
 * @param {React.ReactNode} [p.children]
 * @param {React.ReactNode} [p.sub]
 * @param {React.ReactNode} [p.eyebrow]
 * @param {React.CSSProperties} [p.style]
 */
export function CardTitle({ children, sub, eyebrow, style }) {
  return h('div', { style: { flex: 1, minWidth: 0, ...style } },
    eyebrow ? h('div', { style: { marginBottom: 6 } }, eyebrow) : null,
    h('div', { style: { fontFamily: 'var(--font-title)', fontWeight: 800, fontSize: 'var(--type-card-title)', lineHeight: 1.25, color: 'inherit' } }, children),
    sub ? h('div', { style: { fontSize: 12.5, color: 'var(--tx2)', marginTop: 3, lineHeight: 1.4 } }, sub) : null);
}
